// "Still need help?" escalation
// Authenticated: shows "Contact support" button (opens ContactUsDialog)
// Public/unauthenticated: shows email address instead

import { Box, Typography, Link } from '@/ui';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { ESCALATION_CONFIG } from '../data/supportFaqData';

interface EscalationSectionProps {
  onContactSupport?: () => void;
  isAuthenticated?: boolean;
}

const COLORS = {
  accent: '#004b49',
  accentHover: '#003634',
  textMuted: '#9ca3af',
  textSecondary: '#4b5563',
};

const SUPPORT_EMAIL = 'support@iehub.co.uk';

function EscalationSection({ onContactSupport, isAuthenticated = true }: EscalationSectionProps) {
  return (
    <Box data-testid="features-support-faqs-components-escalation-section-container-action-1" sx={{ pb: 6, fontFamily: 'Inter, sans-serif' }}>
      <Typography data-testid="features-support-faqs-components-escalation-section-text-action-1"
        sx={{
          fontSize: '13px',
          color: COLORS.textMuted,
          mb: 1.5,
          fontFamily: 'Inter, sans-serif',
        }}
      >
        {ESCALATION_CONFIG.preCTACopy}
      </Typography>

      {isAuthenticated && onContactSupport ? (
        <Box data-testid="features-support-faqs-components-escalation-section-container-on-contact-support"
          component="button"
          onClick={onContactSupport}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1.25,
            px: 3,
            py: 1.5,
            borderRadius: '12px',
            fontSize: '13px',
            fontWeight: 600,
            backgroundColor: COLORS.accent,
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.15s',
            fontFamily: 'Inter, sans-serif',
            '&:hover': {
              backgroundColor: COLORS.accentHover,
              transform: 'scale(1.02)',
            },
            '&:active': { transform: 'scale(0.98)' },
          }}
        >
          <ChatBubbleOutlineIcon sx={{ fontSize: 18 }} />
          {ESCALATION_CONFIG.ctaButtonText}
        </Box>
      ) : (
        <Box data-testid="features-support-faqs-components-escalation-section-container-action-2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <EmailOutlinedIcon sx={{ fontSize: 18, color: COLORS.accent }} />
          <Link data-testid="features-support-faqs-components-escalation-section-link-action"
            href={`mailto:${SUPPORT_EMAIL}`}
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: COLORS.accent,
              textDecoration: 'underline',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {SUPPORT_EMAIL}
          </Link>
        </Box>
      )}

      <Typography data-testid="features-support-faqs-components-escalation-section-text-action-2"
        sx={{
          fontSize: '12px',
          color: COLORS.textMuted,
          mt: 1,
          fontFamily: 'Inter, sans-serif',
        }}
      >
        {ESCALATION_CONFIG.availability}
      </Typography>
    </Box>
  );
}

export default EscalationSection;
